<template>
  <BreadCrumb PageTitle="Charts" />
  <div class="row">
    <div class="col-lg-12">
      <div
        class="card mb-25 border-0 rounded-0 bg-white sales-pos-location-box"
      >
        <WeeklySales />
      </div>
    </div>
    <div class="col-lg-6">
      <SalesByPOSLocation />
      <TaskOverview />
      <NumberOfTickets />
      <CustomerSatisfaction />
      <CampaignsChart />
      <AverageEnrollmentRate />
    </div>
    <div class="col-lg-6">
      <WebsiteVisitors />
      <ProjectDistribution />
      <UnresolvedTickets />
      <PerformanceChart />
      <ClientPaymentStatus />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import WeeklySales from "../../template-components/Charts/Charts/WeeklySales.vue";
import SalesByPOSLocation from "../../template-components/Charts/Charts/SalesByPOSLocation.vue";
import TaskOverview from "../../template-components/Charts/Charts/TaskOverview.vue";
import NumberOfTickets from "../../template-components/Charts/Charts/NumberOfTickets.vue";
import CustomerSatisfaction from "../../template-components/Charts/Charts/CustomerSatisfaction.vue";
import CampaignsChart from "../../template-components/Charts/Charts/CampaignsChart.vue";
import AverageEnrollmentRate from "../../template-components/Charts/Charts/AverageEnrollmentRate.vue";
import WebsiteVisitors from "../../template-components/Charts/Charts/WebsiteVisitors.vue";
import ProjectDistribution from "../../template-components/Charts/Charts/ProjectDistribution.vue";
import UnresolvedTickets from "../../template-components/Charts/Charts/UnresolvedTickets.vue";
import PerformanceChart from "../../template-components/Charts/Charts/PerformanceChart.vue";
import ClientPaymentStatus from "../../template-components/Charts/Charts/ClientPaymentStatus.vue";

export default defineComponent({
  name: "ChartsPage",
  components: {
    BreadCrumb,
    WeeklySales,
    SalesByPOSLocation,
    TaskOverview,
    NumberOfTickets,
    CustomerSatisfaction,
    CampaignsChart,
    AverageEnrollmentRate,
    WebsiteVisitors,
    ProjectDistribution,
    UnresolvedTickets,
    PerformanceChart,
    ClientPaymentStatus,
  },
});
</script>